module.exports = __webpack_public_path__ + "img/search-180px.a2ac8024.svg";